import { EstablishmentSetting, CovidModules, ServiceVisibility } from '@/enums';
import { intersection } from 'lodash';

const state = {
};

const getters = {
    hasEstablishmentsAdminServicesEnabled: (state, getters, rootState, rootGetters) => {
        const establishmentsSettings = rootGetters['establishment/getSettings'];
        return establishmentsSettings[EstablishmentSetting.ENABLE_ADMIN_SERVICES];
    },

    getSelectedServiceVisibility: (state, getters, rootState, rootGetters) => {
        const selectedService = rootGetters['services/getSelectedService'];
        return selectedService.visibility;
    },

    getIsCovidModule: (state, getters, rootState, rootGetters) => {
        const establishmentModules = rootGetters['establishment/getEstablishmentModules'];
        return intersection(establishmentModules, CovidModules).length > 0;
    },

    showCalendar: (state, getters) => {
        if (getters.getIsCovidModule) {
            return true;
        }
        return !getters.hasEstablishmentsAdminServicesEnabled ||
            getters.getSelectedServiceVisibility !== ServiceVisibility.CAN_BOOKED_ADMIN_ONLY_BUT_SHOW_PUBLIC;
    },
};

const mutations = {
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
